//element der buchstaben 
//durchscrollen 
//in dem buchstaben scrollen und damit

class AlphabetScroller{


    constructor(){
        //guardclause for the right scope we use?
        if(!$(".el-stores__alph").length){
            return
        }
        this.letterArray = [];
        this.scrollwrapper = $(".scroll-wrapper");
            //this.addFunctionScrollInLetterContainer();
            this.addFunctionScrollLettersFromObservedContainers();
            this.addFunctionFadeInAndFadeOut();
    }
    
    updateLetterArray(){

    }

    addFunctionScrollInLetterContainer(){
        const that = this
        const body =$("body")
        
        let scrollwrapper__alph = $(".scroll-wrapper li");

        var fired = 0;
        $(".el-stores__alph__inner").hover(function () {

            body.toggleClass('no-scroll');


            $(this).on('mousewheel DOMMouseScroll', function (e) {


                if (typeof e.originalEvent.wheelDelta == 'number') {

                    if (fired != 1) {
                        let sw_pos = that.scrollwrapper.attr('style');
                        var sw_pos__top = sw_pos.replace(/[^0-9]/g, '');
                        if (e.originalEvent.wheelDelta < 0) {

                            let sw_pos__top__news = ((sw_pos__top) * -1) - 1;


                            if ((sw_pos__top__news * -1) > scrollwrapper__alph.length) {
                                sw_pos__top__news = scrollwrapper__alph.length;
                            }
                            that.scrollwrapper.attr('style', 'top:' + sw_pos__top__news + 'em;');
                            let cur__alph = scrollwrapper__alph[sw_pos__top__news * -1];

                            document.querySelector('#' + $(cur__alph).data('key')).scrollIntoView({
                                behavior: 'smooth'
                            });


                            fired = 1;
                            that.scrollwrapper.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                                function (event) {
                                    fired = 0;

                                });

                        } else if (e.originalEvent.wheelDelta > 0) {
                            let sw_pos__top__news = ((sw_pos__top) * -1) + 1;
                            if (sw_pos__top__news > 0) {
                                sw_pos__top__news = 0;
                            }
                            that.scrollwrapper.attr('style', 'top:' + sw_pos__top__news + 'em;');


                            let cur__alph = scrollwrapper__alph[sw_pos__top__news * -1];


                            document.querySelector('#' + $(cur__alph).data('key')).scrollIntoView({
                                behavior: 'smooth'
                            });
                            fired = 1;
                            that.scrollwrapper.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
                                function (event) {
                                    fired = 0;
                                    console.log('fired');
                                });
                        }
                    }
                }
            });


        });
    }

    addFunctionScrollLettersFromObservedContainers(){

        const that = this
        if (!!window.IntersectionObserver) { //iexplorer boolean cast - 2016 might be depricated

            const shopCategory = document.querySelectorAll(".el-stores__start");
            const observerOptions = {rootMargin: "0px 0px -88%"}
    
            var key= 0   
            that.scrollwrapper.find('li').each(function(el){ 
                that.letterArray.push($(this).text())
            });
            
            const observerForShopCategorys = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {   
                        const letterOfObserved = entry.target.getAttribute("data-alpha");
                        for (var i=0; i<that.letterArray.length; i++){
                            if (that.letterArray[i] === letterOfObserved)                    
                            key = i;
                        }
                        that.scrollwrapper.attr('style', 'top:' + key*-1 + 'em;');
                    }
                });
            }, observerOptions);

            shopCategory.forEach(function (aShopCategory) {
                observerForShopCategorys.observe(aShopCategory);
            });
        }
    }

    addFunctionFadeInAndFadeOut(){
        const isCityGuide = $('.el-stores');
        
        const options = { rootMargin: '0px 0px -100%'};
        const observer = new IntersectionObserver((entries, observer) =>{
            entries.forEach((entry)=>{
                if(entry.isIntersecting){
                    isCityGuide.addClass('el-stores__alph__show');
                }else{
                    isCityGuide.removeClass('el-stores__alph__show');
                }
            })
        }, options)
        observer.observe(document.getElementById("storelist"))
    }
}